import { createStore, compose, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';

import rootSaga from '../services/sagas';
import tutorialSyncWithLocalStorageMiddleware from './tutorialSyncWithLocalStorageMiddleware';

let _store = {};

/**
 * Creating store. Applying middlewares.
 *
 * @param {Function} rootReducer
 * @param {Object} preloadedState
 * @param {Object} context
 */
export default function (rootReducer, preloadedState = {}, context = {}) {
  const sagaMiddleware = createSagaMiddleware();
  const composeEnhancers =
    (process.env.NODE_ENV === 'local' &&
      typeof window === 'object' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

  const store = createStore(
    rootReducer,
    preloadedState,
    composeEnhancers(
      applyMiddleware(sagaMiddleware, tutorialSyncWithLocalStorageMiddleware)
    )
  );

  sagaMiddleware.run(rootSaga, context);

  if (module.hot) {
    module.hot.accept('../services/redux', () => {
      const nextRootReducer = require('../services/redux').default; // eslint-disable-line global-require
      store.replaceReducer(nextRootReducer);
    });
  }

  _store = store;

  return store;
}

export const getStore = () => _store;



// WEBPACK FOOTER //
// ./src/store/configureStore.js